import tableOperation from '../common/table-operation'

const fetchLocalCallerIDs = async function (
  { commit, state, getters },
  config
) {
  const { paginationConfig } = config
  commit('setTable', paginationConfig)

  const filteredCollection = getters.getSearchedCallerIds
  commit('setTableRecordsCount', filteredCollection?.length)

  const result = {
    outgoingCallerIds: tableOperation.getPaginatedCollection({
      collection: [...filteredCollection],
      paginationConfig: paginationConfig,
    }),
  }

  return Promise.resolve(result)
}

export default fetchLocalCallerIDs
